import { useState, useEffect } from 'react';
import { Product, BrandProfile, Post } from '../types';
import { db } from '../services/firebase';
import { collection, query, onSnapshot } from 'firebase/firestore'; 

export const useProducts = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [brands, setBrands] = useState<BrandProfile[]>([]);
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1. PRODUCTS
    const productsQuery = query(collection(db, "products"));
    const unsubProducts = onSnapshot(productsQuery, (snapshot) => {
      setProducts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Product)));
    });

    // 2. BRANDS (STRICT FILTER VERSION)
    const allUsersQuery = query(collection(db, "users")); 
    
    const unsubBrands = onSnapshot(allUsersQuery, (snapshot) => {
      
      const brandList = snapshot.docs
        .map(doc => {
          const data = doc.data();
          return { id: doc.id, ...data } as any;
        })
        .filter(user => {
          // 🟢 1. STRICT BLOCKS: Kill Thrift and Designer accounts immediately
          const wType = String(user.workspaceType || '').toLowerCase().trim();
          const rName = String(user.rootName || '').toLowerCase().trim();
          const bizName = String(user.businessName || user.displayName || user.name || '').toLowerCase().trim();

          // If they match any thrift/designer criteria, block them globally
          if (wType === 'thrift' || wType === 'designer') return false;
          if (rName === 'thrift' || rName === 'designstudio') return false;
          if (bizName.includes('thrift') || bizName.includes('design studio')) return false;

          // 🟢 2. LOOSE CHECK for actual brands:
          const type = user.accountType ? user.accountType.toLowerCase().trim() : '';
          const isBrandType = type.includes('brand');
          const hasBusinessName = user.businessName && user.businessName.length > 1;

          // Accept if it's a brand OR has a business name (and wasn't blocked above)
          return isBrandType || hasBusinessName;
        })
        .map(user => ({
          id: user.id,
          name: user.businessName || user.displayName || 'Unknown Brand', 
          logo: user.logoUrl || user.logo || user.photoURL || 'https://via.placeholder.com/150',
          banner: user.bannerUrl || user.banner || '',
          description: user.bio || '',
          followers: user.followers || 0,
          rating: user.rating || 5.0,
          isFollowing: false,
          location: user.location || 'South Africa',
          website: user.website || '',
          instagram: user.instagram || '',
          email: user.email || '',
          businessName: user.businessName || user.displayName,
          workspaceType: user.workspaceType || 'brand'
        } as BrandProfile));

      setBrands(brandList);
      console.log(`🔥 Scanner found ${brandList.length} Brands`);
    });

    // 3. POSTS
    const postsQuery = query(collection(db, "posts"));
    const unsubPosts = onSnapshot(postsQuery, (snapshot) => {
      setPosts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Post)));
    });

    setLoading(false);

    return () => {
        unsubProducts();
        unsubBrands();
        unsubPosts();
    };
  }, []);

  return { products, brands, posts, loading };
};